export default __webpack_public_path__ + "18dc34aa0b1f87da5b842d2670b99281.png";